<template>
    <router-link :to="backLink"
                 class="breadcrumbs"
                 :class="{'breadcrumbs--tabs' : tabs}"
                 v-if="!checkwork"
    >
        <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">

        <p class="breadcrumbs__text">{{ text }}</p>
    </router-link>

    <div class="breadcrumbs"
         v-else-if="modeBack && checkwork"
         :class="{'breadcrumbs--tabs' : tabs}"
         @click="goRouterBack"
    >
        <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">

        <p class="breadcrumbs__text">{{ text }}</p>
    </div>

    <div v-else-if="checkwork && current_passing && current_passing.next_lesson_item"
         class="breadcrumbs breadcrumbs--tabs breadcrumbs--right"
         @click="emitElement"
    >
        <p class="breadcrumbs__text">{{ $t('to_next_element') }}</p>

        <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'"
             class="reversed"
             alt="">
    </div>

    <div v-else-if="checkwork && current_passing && current_passing.next_student"
         class="breadcrumbs breadcrumbs--tabs breadcrumbs--right"
         @click="emitElement"
    >
        <p class="breadcrumbs__text">{{ $t('to_next_student') }}</p>

        <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'"
             class="reversed"
             alt="">
    </div>
</template>

<script>
    import env from '../env'
    import { mapGetters } from 'vuex'

    export default {
        props: {
            modeBack: {
                type: Boolean,
                default: false
            },
            alignRight: {
                type: Boolean,
                default: false,
            },
            checkwork: {
                type: Boolean,
                default: false,
            },
            text: {
                type: String,
                default: 'Назад'
            },
            backLink: {
                type: String
            },
            tabs: {
                type: Boolean,
                default: false
            },
            testCheckwork: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                env,
            };
        },
        computed: {
            ...mapGetters([
                'current_passing'
            ]),
            storage_checkwork() {
                return localStorage.getItem('checkwork_element');
            }
        },
        methods: {
            emitElement() {
                const params = {
                    route: this.$route.name,
                    data: Math.random(),
                };

                this.$store.commit('SET_EVENT_EMIITER', params);

                this.$emit('next-element');
            },
            goRouterBack() {
                if (this.testCheckwork) {
                    this.$emit('go-back');
                } else {
                    this.$router.go(-1);
                }
            },
        }
    }
</script>

<style lang="sass" scoped>
    @import '../../sass/variables'

    .breadcrumbs
        width: fit-content
        display: flex
        align-items: center

        color: $gray-j
        font-size: 12px
        cursor: pointer

        &__text
            margin: 0 0 0 15px

        &--tabs
            position: absolute
            top: 50%
            left: 20px
            transform: translateY(-50%)

        &--right
            right: 20px
            left: initial

            .reversed
                margin-left: 15px
                transform: rotate(180deg)

    @media screen and (max-width: 767px)
        .breadcrumbs--tabs
            position: inherit
            transform: none
            left: inherit
            margin-bottom: 10px

</style>
